module.exports = __webpack_public_path__ + "img/bg_2.492c22ee.svg";